import { ratesByState } from '@/app/(marketplace)/quote-builder/electricity-rates/rates';
import { STATES_ABBR_TO_FULL } from '@/models/State';

import { CLIMATE_REGION_BY_ZIP_PREFIX } from './climateRegionOverrides';
import { CLIMATE_REGION_BY_STATE } from './climateRegions';
import { ClimateRegion } from './types';
import { zipToState } from './zipToState';

export type ResolvedRegion = {
  climateRegion: ClimateRegion;
  stateCode: string;
};

export const resolveRegion = (zip: string): ResolvedRegion | undefined => {
  const stateCode = zipToState(zip);
  if (!stateCode || !STATES_ABBR_TO_FULL[stateCode] || !ratesByState[stateCode]) {
    return undefined;
  }

  // Sub-state zip-prefix overrides win over the state default, so LA resolves
  // hot while San Francisco stays marine.
  const climateRegion = CLIMATE_REGION_BY_ZIP_PREFIX[zip.slice(0, 3)] ?? CLIMATE_REGION_BY_STATE[stateCode];

  return climateRegion ? { climateRegion, stateCode } : undefined;
};
